import React from 'react';
import {
    Grid,
    styled,
    Typography,
} from '@mui/material';

import { useAppSelector } from '../../state/hooks';
import BalanceLabel from '../Labels/BalanceLabel';

const classesPrefix = 'areaBalance';

const classes = {
    balanceContainer: `${classesPrefix}-balanceContainer`,
};

const StyledGrid = styled(Grid)(() => {
    return {
        [`& .${classes.balanceContainer}`]: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
    };
});

const DailyAreaBalance = (): React.JSX.Element => {
    const areaBalanceDetailsApiStatus = useAppSelector((state) => { return state.areaBalance.areaBalanceDetailsApiStatus; });
    const areaBalanceDetails = useAppSelector((state) => { return state.areaBalance.areaBalanceDetails; });

    return (
        <StyledGrid
            container
            direction='column'
            justifyContent='flex-end'
        >
            <Grid item xs='auto'>
                <Typography variant='h4'>
                    Daily Area Balance
                </Typography>
            </Grid>
            <Grid item xs={12} className={classes.balanceContainer}>
                <BalanceLabel
                    apiStatus={areaBalanceDetailsApiStatus}
                    balanceType='area'
                    isDailyBalance={true}
                    balanceAmount={areaBalanceDetails.average_daily_balance_amount}
                    unitLabel=' orders/day'
                />
            </Grid>
        </StyledGrid>
    );
};

export default DailyAreaBalance;
